import React, { useEffect, useMemo, useRef, useState } from "react";
import MultiSelectBox from "../../../FormComponents/MultiSelectBox";

const SetGlobalVariablesPlugin = ({ keyName, params, handleParamsData, allFieldsObject }) => {
  const [selectedKeys, setSelectedKeys] = useState([]);
  const originalMappingRef = useRef([]);

  useEffect(() => {
    const list = Array.isArray(params[keyName]) ? params[keyName] : [];
    if (!originalMappingRef.current.length && list.length) {
      originalMappingRef.current = list;
      const initial = list.filter((it) => it?.value).map((it) => it.key);
      setSelectedKeys(initial);
      const copyData = { ...params, [keyName]: initial.map((k) => list.find((it) => it.key === k)) };
      handleParamsData(copyData, keyName);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params[keyName]]);

  const allKeyOptions = useMemo(() => {
    const baseList = Array.isArray(params[keyName]) ? params[keyName] : [];
    const base = originalMappingRef.current.length ? originalMappingRef.current : baseList;
    return base.map((item) => {
      const fd = allFieldsObject?.current?.[item.key];
      const label = fd?.display || fd?.label || fd?.name || fd?.field_type || item.key || "";
      return { id: item.key, label };
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params[keyName], allFieldsObject]);

  // MultiSelectBox has built-in search; no manual filtering needed here

  const applySelection = (keys) => {
    const base = originalMappingRef.current.length
      ? originalMappingRef.current
      : Array.isArray(params[keyName])
        ? params[keyName]
        : [];
    const baseMap = base.reduce((acc, it) => {
      acc[it.key] = it;
      return acc;
    }, {});
    const currentMap = (Array.isArray(params[keyName]) ? params[keyName] : []).reduce((acc, it) => {
      acc[it.key] = it;
      return acc;
    }, {});
    const newList = keys.map((k) => ({
      ...(baseMap[k] || { key: k, value: "", type: "mapped" }),
      ...(currentMap[k] || {})
    }));
    const copyData = { ...params, [keyName]: newList };
    handleParamsData(copyData, keyName);
  };

  const handleMultiChange = (newSelectedOptions) => {
    const next = (newSelectedOptions || []).map((opt) => opt.id);
    setSelectedKeys(next);
    applySelection(next);
  };

  return (
    <div className="builder_form">
      <div style={{ color: "#666", fontSize: "12px" }}>
        Select the global variables you want to map to avoid cluttering the mapping table.
      </div>
      <MultiSelectBox
        options={allKeyOptions}
        valueKey="id"
        labelKey={["label"]}
        selectedData={selectedKeys}
        onChange={(selected) => handleMultiChange(selected)}
        label="Select variables"
        placeholder="Search variables"
      />
    </div>
  );
};

export default SetGlobalVariablesPlugin;
